// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaInstagram_root__CH-NJ","white":"IconSocialMediaInstagram_white__94ccj"};